import {createRouter, createWebHistory} from 'vue-router'
import AdminRoutes from './admin_routes.js'
import PublicRoutes from './public_routes.js'
import TwoFaLayout from '@/layouts/TwoFaLayout.vue'
import {authenticationStore, defaultStore} from '@/main.js'
import {accessRules} from '@/permissions/accessControl'
import {mainMiddleware} from '@shared-utils/router/middlewares/mainMiddleware'

const TwoFaRoutes = {
  path: '/two-fa',
  component: TwoFaLayout,
  children: [
    {
      path: '',
      name: 'two-fa',
      component: () => import('@/views/auth/TwoFaSetup.vue'),
      meta: {title: 'Two-factor authentication'},
    },
  ],
}

const routes = [
  {
    path: '/',
    name: 'index',

    children: [AdminRoutes, PublicRoutes, TwoFaRoutes],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return {top: 0}
  },
})
router.beforeEach(async (to, from, next) => {
  const checkTwoFA = true
  const redirectClientsToApp = true
  const nextRoute = await mainMiddleware({
    to,
    defaultStore,
    authenticationStore,
    router,
    accessRules,
    checkTwoFA,
    redirectClientsToApp,
  })

  if (nextRoute?.external) {
    next(false)
    return
  }

  return nextRoute ? next(nextRoute) : next()
})
export default router
